module.exports = __webpack_public_path__ + "static/media/edit-black.d98d883f.svg";